<template>
  <div>
    <van-count-down
      ref="countDownTime"
      :time="myTime"
      use-slot
      class="countDownTime"
      @change="timeChange"
    >
      <!-- <text
      class=""
      style="color: #000; display: inline-block; font-size: 24rpx"
      v-if="timeData.days"
      >{{ timeData.days }}</text
    ><i
      v-if="timeData.days"
      style="color: #000; display: inline-block; font-size: 24rpx"
      >天</i
    > -->
      <text class="item">{{
        timeData.hours > 9 ? timeData.hours : '0' + timeData.hours
      }}</text
      ><i style="color: #000; display: inline-block">:</i>
      <text class="item">{{
        timeData.minutes > 9 ? timeData.minutes : '0' + timeData.minutes
      }}</text
      ><i style="color: #000; display: inline-block">:</i>
      <text class="item">{{
        timeData.seconds > 9 ? timeData.seconds : '0' + timeData.seconds
      }}</text>
    </van-count-down>
  </div>
</template>

<script>
export default {
  props: {
    startTime: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      timeData: {},
      myTime: 0
    }
  },
  created () {
    this.myTime = this.startTime
    console.log('入参', this.myTime)
  },
  methods: {
    timeChange (e) {
      this.timeData = e.detail
      if (this.timeData.days > 0) {
        this.timeData.hours = this.timeData.days * 24 + this.timeData.hours;
      }
      this.$emit('timeChange', this.timeData)
    }
  }
}
</script>

<style lang="stylus" scoped>2s
.countDownTime{
    display: flex;
}
.item{
  //width 48rpx
  //height 48rpx
  //border-radius 8rpx
 // background #FF6262
  //display inline-block
  //text-align center
 // line-height 40rpx
  font-size 24rpx
  //margin 0 14rpx
  color #000

}
</style>
